export enum Role {
  ADMIN_USER = 'ADMIN_USER',
  AFFILIATE_PARTNER = 'AFFILIATE_PARTNER',
}
